import { useExternalMedia } from './externalMediaContext'

export function ExternalMediaSettings() {
  const { allowed, allow, revoke } = useExternalMedia()
  return <div className="media-settings"><p>Filmy YouTube są obecnie <strong>{allowed ? 'włączone' : 'wyłączone'}</strong>.</p><button className="button button--outline" type="button" onClick={allowed ? revoke : allow}>{allowed ? 'Wycofaj zgodę' : 'Zezwól na filmy YouTube'}</button></div>
}
